import React, { useState } from 'react'

import { Box, CircularProgress, Typography } from '@material-ui/core'
import { BookOpen as BookOpenIcon, Monitor as MonitorIcon } from 'react-feather'

import useSnackbar from 'hooks/useSnackbar'
import useAuth from 'hooks/useAuth'

import { BaseDialog, Permitted } from 'components'
import * as service from 'service'

import useStyles from './styles'
import permissions from 'constants/permissions'

const DialogTrainingPlatform = ({ open, onClose, onMoodle }) => {
  const { company, user } = useAuth()
  const classes = useStyles()
  const snackbar = useSnackbar()
  const [isLoadingPortal, setIsLoadingPortal] = useState(false)

  const handleMoodle = () => {
    onClose()
    onMoodle()
  }

  const handleNewPlatform = async () => {
    setIsLoadingPortal(true)
    const newWindow = window.open('', '_blank')
    try {
      const response = await service.dponet.trainingCourse.portalLink()
      const portalUrl = response?.data?.companyAccessLink?.url
      newWindow.location.href = portalUrl + `?matchEmail=${user?.email}`
      onClose()
    } catch {
      newWindow.close()
      snackbar.open({
        message:
          'Sua empresa não possui cursos cadastrados na nova plataforma.',
        variant: 'error',
      })
    } finally {
      setIsLoadingPortal(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={onClose}
      title="Escolha a Plataforma de Treinamentos"
      dialogSize="sm"
      fullWidth
      withoutBottomDivider
    >
      <Box className={classes.optionsRow}>
        <Permitted tag={permissions.MOODLE_TRAININGS.VIEW}>
          <Box className={classes.optionCard} onClick={handleMoodle}>
            <Box className={classes.optionIcon}>
              <BookOpenIcon size={24} />
            </Box>
            <Typography className={classes.optionLabel}>
              Plataforma antiga
            </Typography>
            <Typography className={classes.optionDescription}>
              Acesse os treinamentos pela plataforma anterior
            </Typography>
          </Box>
        </Permitted>
        <Permitted tag={permissions.NEW_PLATFORM_COURSE.TREINING_PORTAL}>
          <Box
            className={classes.optionCard}
            onClick={isLoadingPortal ? undefined : handleNewPlatform}
          >
            {isLoadingPortal ? (
              <CircularProgress size={24} />
            ) : (
              <Box className={classes.optionIcon}>
                <MonitorIcon size={24} />
              </Box>
            )}
            <Typography className={classes.optionLabel}>
              Nova Plataforma
            </Typography>
            <Typography className={classes.optionDescription}>
              Acesse os treinamentos publicados pela&nbsp;
              <b>{company?.dpoData?.name}</b> para nova plataforma de cursos.
            </Typography>
          </Box>
        </Permitted>
      </Box>
    </BaseDialog>
  )
}

export default DialogTrainingPlatform
